import { Link } from 'react-router';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';

import type { ArticleMeta } from '../types.ts';

import { ArticleTag } from './article-tag.tsx';

type ArticleCardSource = 'articles_index' | 'my_economy';

export function ArticleCard({ meta, source }: { meta: ArticleMeta; source: ArticleCardSource }) {
  return (
    <div className="flex h-full flex-col gap-4 rounded-2xl bg-v1-background-60 pb-8 shadow-[2px_4px_12.5px_rgba(0,0,0,0.05)] transition-shadow hover:shadow-[2px_6px_16px_rgba(0,0,0,0.08)]">
      <Link
        to={`/${meta.slug}`}
        className="flex flex-col gap-4 no-underline"
        onClick={() => {
          sendUserPortalEvent('article_card_clicked', { article_slug: meta.slug, source });
        }}
      >
        <img
          src={meta.thumbSrc}
          alt={meta.thumbAlt}
          className="aspect-video w-full rounded-t-2xl object-cover"
        />
        <div className="flex flex-col gap-4 px-4">
          <h2 className="typography-v1-h3 text-v1-background-200 underline decoration-from-font underline-offset-2">
            {meta.title}
          </h2>
          <p className="line-clamp-2 typography-v1-body3 text-v1-background-200">
            {meta.description}
          </p>
        </div>
      </Link>
      {meta.tags.length > 0 && (
        <div className="mt-auto flex flex-wrap gap-2 px-4">
          {meta.tags.map((tag) => (
            <ArticleTag key={tag} tag={tag} />
          ))}
        </div>
      )}
    </div>
  );
}
